export default () => ({
	tabIndex: 0,
	isMobileCollapseOpen: false,
});
